import { useEffect, useRef, useState } from 'react';

import { getDataFromStorage, saveDataToStorage } from './storage';

// ---

type AuthorizedInfo = { authorized: 'Y' | 'N'; userId: string };
type UseAuthorizedInfoProps = {
  userId?: string;
};

function useAuthorizedInfo(props?: UseAuthorizedInfoProps): AuthorizedInfo {
  const userId = props?.userId;

  const isSaved = useRef<boolean>(false);
  const [authorizedInfo, setInfo] = useState<AuthorizedInfo>({ userId: '', authorized: 'N' });

  useEffect(() => {
    if (userId && !isSaved.current) {
      isSaved.current = true;
      saveDataToStorage({ userId });
    }

    if (userId) {
      return setInfo({ userId: userId.toString(), authorized: 'Y' });
    }

    const storageData = getDataFromStorage();

    if (storageData && storageData.userId) {
      return setInfo({ userId: storageData.userId.toString(), authorized: 'N' });
    }

    setInfo({ userId: '', authorized: 'N' });
  }, [userId]);

  return authorizedInfo;
}

export default useAuthorizedInfo;
